<forge-card class="chart" no-padding>
  <forge-toolbar>
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
    </div>

    <forge-icon-button slot="end" tabindex="0" (click)="openSettings()" class="chart-settings"
      telemetry="Chart settings" aria-haspopup="true" aria-label="chart settings">
      <forge-tooltip>Chart settings</forge-tooltip>
      <forge-icon name="settings"></forge-icon>
    </forge-icon-button>
  </forge-toolbar>

  <div class="metadata-padding">
    @if (isLoaded) {
      <div class="chart-container">
        @if (showChart) {
          <chartjs-container [config]="chartConfig">
          </chartjs-container>
        }
        @if (!chartHasData) {
          <div>
            Not enough data to display graph
          </div>
        }
        @if (errorMessage) {
          <div class="error-red">
            {{errorMessage}}
          </div>
        }
      </div>
    }

    @if (!isLoaded) {
      <busy-indicator [chart]="true"></busy-indicator>
    }
  </div>
</forge-card>
